module.exports = __webpack_public_path__ + "static/zakochani-89af795fa30f148c7550660ee77a6fd8.png";